
import { defineComponent } from "vue";
import { getFirestore, collection, addDoc, CollectionReference, setDoc, doc } from "firebase/firestore"

interface ComponentData {
  showModal: boolean;
  submissionsRef: CollectionReference | null;
  playerName: string;
  fullName: string;
  businessEmail: string;
  jobTitle: string;
  optIn: boolean;
  isGameCompleted: boolean;
  loading: boolean;
}

export default defineComponent({
  name: "RegisterPopup",
  data: (): ComponentData => ({
    showModal: false,
    submissionsRef: null,
    playerName: '',
    fullName: '',
    businessEmail: '',
    jobTitle: '',
    optIn: true,
    isGameCompleted: false,
    loading: false
  }),
  methods: {
    async submitForm() {
      if (!this.submissionsRef) {
        return;
      }
      try {
        this.loading = true;
        const docRef = await addDoc(this.submissionsRef, {
          playerName: this.playerName,
          score: window.pointsEarned || 0,
        });
        await setDoc(doc(this.submissionsRef, docRef.id, "details", "private"), {
          fullName: this.fullName,
          businessEmail: this.businessEmail,
          jobTitle: this.jobTitle,
          optIn: this.optIn
        });
        window.showOrHideRegisterPopup(false);
        window.showOrHideLeaderboardPopup(true);
      } catch (e) {
        console.error("Error adding document: ", e);
      } finally {
        this.loading = false;
      }
    },
    showPopup(show: boolean, isGameCompleted?: boolean) {
      window.showOrHideInstructionPopup1(false);
      window.showOrHideInstructionPopup2(false);
      window.showOrHideInstructionPopup3(false);
      window.showOrHideInstructionPopup4(false);
      window.showOrHideInstructionPopup5(false);
      this.showModal = show;
      if (isGameCompleted) {
        this.isGameCompleted = true;
      }
    },
    isRegister() {
      return this.showModal
    }
  },
  mounted() {
    const db = getFirestore();
    this.submissionsRef = collection(db, "submissions");
    window.showOrHideRegisterPopup = this.showPopup;
    window.isRegisterOpen = this.isRegister
  }
});
